module.exports = __webpack_public_path__ + "img/viitorul-logo-icon.9285bae1.png";